function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: 50,
    height: 50,
    viewBox: "0 0 1.5 1.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "1.92px",
      fill: "#000000",
      strokeWidth: 0.03999
    },
    x: 0.14322285,
    y: 1.4494152,
    id: "text5144"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan5142",
    style: {
      fontSize: "1.92px",
      strokeWidth: 0.03999
    },
    x: 0.14322285,
    y: 1.4494152
  }, "T")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.228fca31a987ee08051e5e9b68b10743.svg";
export { ForwardRef as ReactComponent };